/**
 * menuMain.js
 */

// Import
import './menuMain.scss';
import $ from 'jquery';

$(document).ready(function() {

});

